import { useState, useEffect } from 'react';
import useAuth from './useAuth';
import { IOD_BASE_URL } from '../config';
import API from '../API';

const initialState = {
  page: 0,
  ioditem: '',
  total_pages: 0,
  total_results: 0,
  imageUrl: '',
};

export const useInjuryFetch = (id) => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const accessToken = auth.auth.accessToken;

  useEffect(() => {
    console.log("Binne fetch voor id")
    if (!id) return; // Prevents unnecessary API calls
    console.log("Binne fetch voor fetch")
    const fetchIODitem = async () => {
      try {
        setLoading(true);
        setError(false);

        // Fetch stock item data
        const ioditem = await API.fetchIODitem(id, accessToken);
        console.log(ioditem.ioditem[0])

        setState(( ) => ({
          
          ...ioditem.ioditem[0]
        }));
      } catch (error) {
        console.error('Error fetching stock item:', error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchIODitem();

    return () => {
      // Cleanup old image URL to prevent memory leaks
      if (state.imageUrl) {
        URL.revokeObjectURL(state.imageUrl);
      }
    };
  }, [id, trigger]);

  return { state, loading, error, setLoading, setTrigger };
};
